import { resolveAssetUrl } from "../../resolveAssetUrl";
import { TextNodeType } from "../../CommonLandingMweb.types";
import {
  Card,
  CardInfo,
  CardTitle,
  ChevronWrap,
  Container,
  List,
  PlanIcon,
  Separator,
  TagImg,
  TextBlock,
  Title,
  TitleRow,
} from "./Styles";
import { BlueChev } from "@tm/static/icons";
import FormattedText from "../../../FormattedText/FormattedText";

export interface TravelPlanItem {
  title?: TextNodeType;
  info?: TextNodeType;
  type?: string;
  icon?: string | Record<string, unknown>;
  tagURL?: string | Record<string, unknown>;
}

interface TravelPlansProps {
  plans?: TravelPlanItem[];
  isVisible?: boolean;
  onPlanPress?: (plan: TravelPlanItem) => void;
}

export const TravelPlans = ({
  plans,
  isVisible = true,
  onPlanPress,
}: TravelPlansProps) => {
  if (!isVisible || !plans?.length) return null;

  return (
    <Container>
      <List>
        {plans.map((plan, index) => {
          const iconUrl = resolveAssetUrl(plan.icon);
          const tagUrl = resolveAssetUrl(plan.tagURL);
          return (
          <Card
            key={`${plan.type || "plan"}-${index}`}
            onClick={() => onPlanPress?.(plan)}
          >
            {iconUrl ? <PlanIcon src={iconUrl} alt="" /> : null}
            <TextBlock>
              <TitleRow>
                <CardTitle>
                  <FormattedText value={plan.title} />
                </CardTitle>
                {tagUrl ? <TagImg src={tagUrl} alt="" /> : null}
              </TitleRow>
              <CardInfo>
                <FormattedText value={plan.info} />
              </CardInfo>
            </TextBlock>
            <ChevronWrap>
              <BlueChev />
            </ChevronWrap>
          </Card>
          );
        })}
      </List>
    </Container>
  );
};
